export function getTenantSlugFromHost() {
  const hostname = window.location.hostname.toLowerCase();
  if (hostname === 'localhost' || hostname === '127.0.0.1') return null;
  const parts = hostname.split('.');
  if (parts.length < 2) return null;
  const subdomain = parts[0];
  if (['www', 'api', 'app', 'admin', 'platform'].includes(subdomain)) return null;
  if (hostname.endsWith('.localhost')) return subdomain;
  return subdomain;
}
